import { render, staticRenderFns } from "./YoutubePlayer.vue?vue&type=template&id=dea9556e&scoped=true"
import script from "./YoutubePlayer.vue?vue&type=script&lang=js"
export * from "./YoutubePlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea9556e",
  null
  
)

export default component.exports